var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 52 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7",
    d: "M0 0h52v52H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8",
    d: "M21.667 17.333h8.667v-3.25a7.583 7.583 0 117.583 7.583h-3.25v8.667h3.25a7.583 7.583 0 11-7.583 7.583v-3.25h-8.667v3.25a7.583 7.583 0 11-7.583-7.583h3.25v-8.666h-3.25a7.583 7.583 0 117.583-7.583zm-4.333 0v-3.25a3.25 3.25 0 10-3.25 3.25zm0 17.333h-3.25a3.25 3.25 0 103.25 3.25zm17.333-17.333h3.25a3.25 3.25 0 10-3.25-3.25zm0 17.333v3.25a3.25 3.25 0 103.25-3.25zm-13-13v8.667h8.667v-8.666z",
    fill: "#08587d"
  })));
}

export default SvgCommand;